import React from "react";
import { Button } from "react-bootstrap";
import "./index.scss";
const AddButton = ({ label = "Add", onClick }) => {
  return (
    <Button variant="primary" onClick={onClick}>
      + {label}
    </Button>
  );
};

export default AddButton;
